import { Order, OrderItem } from '@/models';
import { GenericService } from './generic.service';
import apiClient from './client/apiClient';


export class WebshopCartService extends GenericService<Order> {
  constructor(organisationalUnit: string) {
    super(`v1/webshop/${organisationalUnit}/cart`);
  }

  async getCart(): Promise<Order> {
    return (await apiClient.get<Order>(this.endpoint)).data;
  }

  async addItem(orderItem: OrderItem): Promise<Order> {
    const payload: Record<string, any> = { ...orderItem };

    if (payload.patientId) {
      payload.patient_id = payload.patientId;
    }

    return (await apiClient.post<Order>(this.endpoint, payload)).data;
  }

  async updateItem(itemId: string, orderItem: OrderItem): Promise<OrderItem> {
    const payload: Record<string, any> = { ...orderItem };

    if (payload.patientId) {
      payload.patient_id = payload.patientId;
    }

    return (await apiClient.put<OrderItem>(`${this.endpoint}/${itemId}`, payload)).data;
  }

  async removeItem(itemId: string): Promise<void> {
    await apiClient.delete<void>(`${this.endpoint}/${itemId}`);
  }

  async checkout(): Promise<{ message: string; error?: string }> {
    return await apiClient.post(`${this.endpoint.replace('/cart', '')}/checkout`);
  }
}
